export default __webpack_public_path__ + "static/media/central_andes_1_13.c5f9dd02.JPG";